import React from 'react';
import { string } from 'prop-types';
function ArrowDropDownIcon({
  className
}) {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M3 8l9 9 9-9"
  })));
}
ArrowDropDownIcon.propTypes = {
  /**
   * The CSS class that will be applied to the SVG node.
   */
  className: string
};
export default ArrowDropDownIcon;